/**
 * Месяц и год в родительном падеже: «декабря 2025».
 *
 * Зачем своя таблица. `toLocaleDateString('ru-RU', { month: 'long' })`
 * даёт именительный — «декабрь», и строка «В приложении с декабрь 2025»
 * получается неграмотной. Родительный Intl отдаёт только когда в наборе
 * есть день: «23 декабря 2025 г.». Дня здесь нет — точная дата регистрации
 * ничего не решает, — поэтому падеж задаётся таблицей.
 *
 * Где день есть (`day: 'numeric'` вместе с `month: 'long'`), эта утилита
 * не нужна: Intl там уже склоняет верно.
 */
const MONTHS_GENITIVE = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря',
];

/**
 * @param {Date|string|number} value - Дата
 * @returns {string|null} - «декабря 2025» либо null, если дату не разобрать
 */
export const formatMonthYear = (value) => {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  return `${MONTHS_GENITIVE[date.getMonth()]} ${date.getFullYear()}`;
};

export default formatMonthYear;
